var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Default_Subject",
    transform: "translate(23644 608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Human_biology",
    "data-name": "Human biology",
    transform: "translate(-1891 -3394)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21753 2786)",
    opacity: 0.16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6695",
    "data-name": "Group 6695",
    transform: "translate(-23573.111 -1190.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    transform: "translate(-48.889 604.11)",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "education",
    transform: "translate(-49 609.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M36.482,35.049h0a1.646,1.646,0,0,0-1.159.471,1.6,1.6,0,0,0-.487,1.151V61a1.644,1.644,0,0,0,1.656,1.622c3.85.009,10.3.8,14.75,5.363V42.524a1.532,1.532,0,0,0-.227-.821C47.359,35.934,40.341,35.058,36.482,35.049Z",
    transform: "translate(-29.412 -35.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M173.157,60.994V36.67a1.6,1.6,0,0,0-.487-1.151,1.647,1.647,0,0,0-1.159-.471h0c-3.858.009-10.877.885-14.529,6.654a1.532,1.532,0,0,0-.227.821V67.978c4.45-4.567,10.9-5.354,14.75-5.363A1.644,1.644,0,0,0,173.157,60.994Z",
    transform: "translate(-132.356 -35.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M189.362,71.8h-1.2V92.537a4.232,4.232,0,0,1-4.218,4.221c-3.266.008-8.65.646-12.463,4.255,6.6-1.615,13.548-.565,17.51.338a1.654,1.654,0,0,0,2.024-1.612V73.455A1.656,1.656,0,0,0,189.362,71.8Z",
    transform: "translate(-144.795 -66.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M2.853,92.537V71.8h-1.2A1.656,1.656,0,0,0,0,73.455V99.74a1.654,1.654,0,0,0,2.024,1.612c3.962-.9,10.915-1.953,17.51-.338-3.813-3.609-9.2-4.247-12.463-4.255A4.231,4.231,0,0,1,2.853,92.537Z",
    transform: "translate(0 -66.728)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommon);
export default __webpack_public_path__ + "static/media/Common.e3837580.svg";
export { ForwardRef as ReactComponent };